import { ADD_TMP_SESSION, AUTO_CALL, CHANGE_TOTAL_SIP_INSTANCE, COUNT_CONFIG_SIP, DECREASE_TOTAL_SIP_INSTANCE, ENABLE_SIP_CALL_IN, INCREASE_TOTAL_SIP_INSTANCE, SAVE_DATA, SAVE_OLD_NUMBER_CTH, SIP_GW_INVITE_ROOMS, SIP_GW_LISTEN, TOTAL_IN } from './actionTypes';
/**
 * Invites room participants to the conference through the SIP Jibri service.
 *
 * @param {JitsiMeetConference} conference - The conference to which the rooms
 * will be invited to.
 * @param {Immutable.List} rooms - The list of the "videosipgw" type items to
 * invite.
 * @returns {void}
 */
export function inviteVideoRooms(conference, rooms) {
    return {
        type: SIP_GW_INVITE_ROOMS,
        conference,
        rooms
    };
}
export function _listen(username, password, domain, conference, isShowPopup = true) {
    return {
        type: SIP_GW_LISTEN,
        username,
        password,
        domain,
        conference,
        isShowPopup
    };
}
export function saveData(token, sipId, conference, errorMessage) {
    return {
        type: SAVE_DATA,
        token,
        sipId,
        conference,
        errorMessage
    };
}
export function autoCalled() {
    return {
        type: AUTO_CALL
    };
}
export function enableSipCallIn(token, sipId, conference, numberIn) {
    return {
        type: ENABLE_SIP_CALL_IN,
        token,
        sipId,
        conference,
        numberIn
    };
}
export function totalIn(number) {
    return {
        type: TOTAL_IN,
        number
    };
}
export function addTmpSession(id, session) {
    return {
        type: ADD_TMP_SESSION,
        id,
        session
    };
}
export function saveOldNumberCTH(oldNumber) {
    return {
        type: SAVE_OLD_NUMBER_CTH,
        oldNumber
    };
}
export function countConfigSip(numberIn) {
    return {
        type: COUNT_CONFIG_SIP,
        numberIn
    };
}
export function changeTotalSipInstance(number) {
    return {
        type: CHANGE_TOTAL_SIP_INSTANCE,
        number
    };
}
export function increaseTotalSipInstance(number) {
    return {
        type: INCREASE_TOTAL_SIP_INSTANCE,
        number
    };
}
export function decreaseTotalSipInstance(number) {
    return {
        type: DECREASE_TOTAL_SIP_INSTANCE,
        number
    };
}
